import React, {useContext, useEffect} from 'react';
import {Grid} from '@mantine/core';
import {useFormikContext} from 'formik'
import MantineSelectField from "../../../../FormikUtils/MantineSelectField";
import MantineNumberField from "../../../../FormikUtils/MantineNumberField";
import MantineInputField from "../../../../FormikUtils/MantineInputField";
import withMultipleContexts from "../../../../../../context/utils/withMultipleContexts";
import loadMotovehiculoData from "../../../../../../context/products/MotovehiculoContext/loadMotovehiculoData";
import MotovehiculoContextProvider
    from "../../../../../../context/products/MotovehiculoContext/MotovehiculoContextProvider";
import MotovehiculoContext from "../../../../../../context/products/MotovehiculoContext/MotovehiculoContext";
import {findSelectedLabel} from "../../../../../utils/findSelectedLabel";

function MotovehiculoForm(props) {
    const {
        formField: {
            motovehiculo: {
                patente,
                marca,
                anio,
                version,
                valorAdicional,
                ceroKm,
            },
        },
        vehicleDetails
    } = props;
    const {values, setFieldValue} = useFormikContext();

    const {
        marcas,
        anios,
        versiones,
        updateVersions,
        isLoadingVersions
    } = useContext(MotovehiculoContext);

    const cerokm_options = [
        {value: 'true', label: 'Si'},
        {value: 'false', label: 'No'}
    ];

    useEffect(() => {
        if (values.motovehiculo.anio !== '') {
            setFieldValue(version.name, '', false);
            updateVersions(values.motovehiculo.marca, values.motovehiculo.anio, true);
        }
    }, [values.motovehiculo.anio, values.motovehiculo.marca]);

    return (
        <React.Fragment>
            <Grid gutter="md" justify="center" align="center">
                <Grid.Col xs={12} sm={6}>
                    <MantineSelectField
                        name={`motovehiculo.${marca.name}`}
                        label={marca.label}
                        data={marcas}
                        searchable
                        withAsterisk
                        onChangeAction={value => {
                            vehicleDetails.current = {
                                ...vehicleDetails.current,
                                detalle_marca: findSelectedLabel(marcas, value)
                            }
                        }}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineSelectField
                        name={`motovehiculo.${anio.name}`}
                        label={anio.label}
                        data={anios}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineSelectField
                        name={`motovehiculo.${version.name}`}
                        label={version.label}
                        loading={isLoadingVersions}
                        data={versiones}
                        searchable
                        withAsterisk
                        onChangeAction={value => {
                            vehicleDetails.current = {
                                ...vehicleDetails.current,
                                detalle_version: findSelectedLabel(versiones, value)
                            }
                        }}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineSelectField
                        name={`motovehiculo.${ceroKm.name}`}
                        label={ceroKm.label}
                        data={cerokm_options}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={`motovehiculo.${patente.name}`}
                        label={patente.label}
                        withAsterisk={values.motovehiculo.ceroKm === "false"}
                        styles={{input: {textTransform: "uppercase"}}}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineNumberField
                        name={`motovehiculo.${valorAdicional.name}`}
                        label={valorAdicional.label}
                        // min={0}
                        // max={2000000}
                        styles={{input: {textAlign: "right"}}}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}/>
            </Grid>
        </React.Fragment>
    );
}

export default withMultipleContexts(MotovehiculoForm, [
    {
        loadDataFunctions: [loadMotovehiculoData],
        ContextProvider: MotovehiculoContextProvider,
        dataKey: 'motovehiculoData',
        storageKey: 'motovehiculoData',
    }
])